/**
 * Shared implementation for handling Node.js HTTP requests.
 * Used by both NodejsHttpClient and BinaryNodejsHttpClient.
 *
 * @param https The Node.js https module (or compatible)
 * @param url The URL to make the request to
 * @param requestOptions The request configuration
 * @param serializeData Function to serialize the request data for writing
 */
export function executeNodejsRequest(https, url, requestOptions, serializeData) {
    return new Promise((resolve, reject) => {
        const req = https.request(url, requestOptions, (res) => {
            let body = '';
            res.on('data', (chunk) => {
                body += chunk;
            });
            res.on('end', () => {
                const ok = res.statusCode >= 200 && res.statusCode <= 299;
                const mediaType = res.headers['content-type'];
                const data = body !== '' && typeof mediaType === 'string' && mediaType.startsWith('application/json')
                    ? JSON.parse(body)
                    : body;
                resolve({
                    status: res.statusCode,
                    statusText: res.statusMessage,
                    ok,
                    data
                });
            });
        });
        req.on('error', (error) => {
            reject(error);
        });
        if (requestOptions.data !== null && requestOptions.data !== undefined) {
            req.write(serializeData(requestOptions.data));
        }
        req.end();
    });
}
//# sourceMappingURL=NodejsHttpRequestUtils.js.map